import Avatar from '@zenbusiness/zui/Avatar';
import { styled } from '@zenbusiness/zui/styles';

export const MonthWrapperStyled = styled('div')(({ theme }) => ({
  width: '100%',
  height: '76px',
  padding: '0 16px',
  display: 'flex',
  borderTop: '1px solid',
  borderColor: theme.palette.border.main,
  justifyContent: 'space-between',
  alignItems: 'center',
  [theme.breakpoints.up('md')]: {
    height: '112px'
  },
  '&:hover': {
    boxShadow: '0px 4px 16px 2px rgba(0, 0, 0, 0.12)',
    cursor: 'pointer'
  },
  '&:active': {
    backgroundColor: theme.palette.background.grey.main,
    cursor: 'pointer'
  }
}));

export const CircleStyled = styled(Avatar)(({ theme }) => ({
  backgroundColor: theme.palette.background.grey.dark,
  width: '40px',
  height: '40px',
  [theme.breakpoints.up('md')]: {
    width: '80px',
    height: '80px'
  }
}));
